import api from "./api";

export const getBanners = async () => {
  return api.get("/v1/cp/banners/");
};
